import { RootState } from "@/vuex/types";
import { GetterTree } from "vuex";
import { ThirdPartyAppState } from "./thirdPartyApp.types";

type ThirdPartyAppGetter = GetterTree<ThirdPartyAppState, RootState>;

export const getters: ThirdPartyAppGetter = {
  loading(state): boolean {
    return state.loading;
  },
  scopes(state) {
    return state.scopes;
  }
};
